const ALLOWED_FILE_TYPE = ['xlsx']

export default ALLOWED_FILE_TYPE